// extracted by mini-css-extract-plugin
export default {"header":"H3_header__dL5Op"};